// extracted by mini-css-extract-plugin
export default {"text":"style_text__pXlkS","listItemWrapper":"style_listItemWrapper__SzfGO"};